import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { License } from '@cpd-app/core-module/models';

export const licenseFeatureKey = 'license';

export interface LicenseState extends EntityState<License> {
  error: any;
}

export const licenseStateAdapter: EntityAdapter<License> =
  createEntityAdapter<License>({
    selectId: (license: License) => license.id,
    sortComparer: false
  });

export const initialLicenseState: LicenseState =
  licenseStateAdapter.getInitialState({
    error: null
  });

export const { selectIds, selectEntities, selectAll, selectTotal } =
  licenseStateAdapter.getSelectors();
